import { Splide } from "@splidejs/splide";

export class Carousels {
  constructor() {
    this.init();
  }

  init() {
    const carouselWrappers = document.querySelectorAll(".carousel.splide");

    carouselWrappers.forEach((carouselWrapper) => {
      this.createCarousel(carouselWrapper);
    });
  }

  createCarousel(carouselWrapper) {
    const arrowLeft = carouselWrapper.querySelector(".carousel__arrow--prev");
    const arrowRight = carouselWrapper.querySelector(".carousel__arrow--next");
    const items = carouselWrapper.querySelectorAll(".carousel__item");

    const i18n = this.getI18nConfig();

    const splide = new Splide(carouselWrapper, {
      type: "loop",
      perPage: 3,
      perMove: 1,
      pagination: false,
      arrows: false,
      gap: "1.5rem",
      focus: "center",
      flickMaxPages: 0.3,
      keyboard: "focused",
      updateOnMove: true,
      breakpoints: {
        1200: {
          perPage: 2,
          focus: "left",
        },
        800: {
          perPage: 1,
        },
      },
      dragMinThreshold: {
        mouse: 0,
        touch: 10,
      },
      i18n,
    });

    this.setupCarouselEvents(splide, arrowLeft, arrowRight);
    splide.mount();
  }

  setupCarouselEvents(splide, arrowLeft, arrowRight) {
    // Setup arrow navigation
    if (arrowLeft) {
      arrowLeft.addEventListener("click", () => {
        splide.go("<");
      });
    }

    if (arrowRight) {
      arrowRight.addEventListener("click", () => {
        splide.go(">");
      });
    }

    // Setup click navigation
    splide.on("click", (event) => {
      splide.go(event.index);
    });
  }

  getI18nConfig() {
    const isEnglish = document.documentElement.lang === "en";

    return isEnglish
      ? {
          prev: "Previous slide",
          next: "Next slide",
          select: "Select a slide to show",
          slideX: "Go to slide %s",
          carousel: "Slideshow",
          slide: "Slide",
          slideLabel: "%s of %s",
        }
      : {
          prev: "Vorheriger Slide",
          next: "Nächster Slide",
          select: "Wähle einen Slide aus",
          slideX: "Gehe zu Slide %s",
          carousel: "Slideshow",
          slide: "Slide",
          slideLabel: "%s von %s",
        };
  }
}
